const clonedeepwith = require('lodash.clonedeepwith'),
	isstring        = require("lodash.isstring")


module.exports = function (v) {
	return clonedeepwith(v, function (i) {
		if (isstring(i)) {
			return unescape(i)
		}
	})
}



// WEBPACK FOOTER //
// ./src/filter/formatDeep.js